import { z } from 'zod';

export const PublicReleaseReasonSchema = z.enum([
  'SOLD',
  'SCRAPPED',
  'CUSTOMER_REQUEST',
  'DATA_CORRECTION',
  'OTHER',
]);

export type PublicReleaseReason = z.infer<typeof PublicReleaseReasonSchema>;

export const ReleaseVehicleOwnershipBodySchema = z.object({
  releaseReason: PublicReleaseReasonSchema,
  releaseNotes: z.string().trim().optional(),
});

export type ReleaseVehicleOwnershipBody = z.infer<typeof ReleaseVehicleOwnershipBodySchema>;

export const TransferVehicleOwnershipBodySchema = z.object({
  newPartyId: z.uuid(),
  acquiredAt: z.iso.date().optional(),
});

export type TransferVehicleOwnershipBody = z.infer<typeof TransferVehicleOwnershipBodySchema>;

export const TransferVehicleOwnershipResponseSchema = z.object({
  newCustomerVehicleId: z.uuid(),
});

export type TransferVehicleOwnershipResponse = z.infer<
  typeof TransferVehicleOwnershipResponseSchema
>;
